import React from 'react'
import { FieldWrapper, Label, InputCell, StyledInput, Comment, ErrorInline, ErrorText } from './styled'
import { ErrorIcon } from "../icons"
import { useTranslation } from 'react-i18next'

const LabeledInput = ({ label, id, comment, layout, error, errorMessage, ...props }) => {
    const inputId = id || `input-${props.name || Math.random().toString(36).slice(2, 9)}`
    const isRow = layout === 'row'
    const { t } = useTranslation()

    return (
        <FieldWrapper $row={isRow}>
            {label && <Label $row={isRow} htmlFor={inputId}>{label}</Label>}

            <InputCell id={inputId} $row={isRow}>
                <StyledInput
                  {...props}
                  aria-invalid={!!error}
                  aria-describedby={error && errorMessage ? `${inputId}-error` : undefined}
                />
            </InputCell>

            {error && (
              <ErrorInline $row={isRow} role="alert" aria-live="polite">
                <ErrorIcon />

                {errorMessage ? <ErrorText id={`${inputId}-error`}>{ errorMessage }</ErrorText> : null}
              </ErrorInline>
            )}

            {comment ? <Comment $row={isRow}>{comment}</Comment> : null}
        </FieldWrapper>
    )
}

export default LabeledInput
